import AddonModel from '@/models/grid/AddonModel';
import { AddonModelState } from '@/typings/interfaces/state/Addon';
import { AddonLeaderboardData } from './Data';

interface AddonLeaderboardState extends AddonModelState {
  nameFieldId: string;
  uniqueFieldId: string;
}

export class AddonLeaderboardModel extends AddonModel<AddonLeaderboardData, AddonLeaderboardState> {
  parseAddon(data: AddonLeaderboardData): void {
    const state = this.state;
    state.alias = data.alias;
    state.nameFieldId = data.settings.name_field_id;
    state.uniqueFieldId = data.settings.unique_field_id;
  }

  authorSignature(): string {
    return 'Mihai-Alexandru Paun';
  }
}
